import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useTheme } from '../../contexts/ThemeContext';
import { OAuthButtons } from '../ui/modals/UserModal/components/OAuthButtons';

interface Props {
  onDismiss: () => void;
}

export const AuthGateOverlay: React.FC<Props> = ({ onDismiss }) => {
  const { signInWithGoogle, signInWithApple, loading } = useAuth();
  const { theme } = useTheme();

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm p-4">
      <div className="bg-[var(--clue-bg-primary)] rounded-2xl border border-[var(--clue-border-mid)] shadow-xl max-w-sm w-full p-6">
        {/* Close */}
        <div className="flex justify-end mb-2">
          <button
            onClick={onDismiss}
            className="w-8 h-8 rounded-full flex items-center justify-center hover:bg-[var(--clue-bg-secondary)] transition-colors text-[var(--clue-text-tertiary)]"
            aria-label="Close"
          >
            &#10005;
          </button>
        </div>

        <div className="flex flex-col items-center gap-4 text-center">
          <div className="text-4xl">🔓</div>
          <h3 className="text-lg font-semibold font-serif text-[var(--clue-text-primary)]">
            Sign in to continue
          </h3>
          <p className="text-sm text-[var(--clue-text-secondary)] leading-relaxed">
            Create a free account to unlock the rest of the course and save your progress.
          </p>

          <div className="w-full mt-2">
            <OAuthButtons
              mode="signup"
              authLoading={loading}
              theme={theme === 'dark' ? 'dark' : 'light'}
              googleButtonLabel="Continue with Google"
              appleButtonLabel="Continue with Apple"
              onGoogleLogin={signInWithGoogle}
              onAppleLogin={signInWithApple}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
